import { CheckedIcon } from '@/components/ui/Icons/Icons';
import { Typography } from '@/components/ui/Typography/Typography.styles';

import * as S from './CopySuccess.styles';

export const CopySuccess = ({ message }: { message: string }) => {
  return (
    <S.Container data-testid="copy-toast">
      <S.Icon>
        <CheckedIcon color="var(--toast-text-main)" />
      </S.Icon>
      <Typography variant="title4">{message}</Typography>
    </S.Container>
  );
};
